import React, { FC } from 'react';
import DataTableHeading from '@/util/DataTableHeading';
import {
  ColumnCategory,
  ColumnHeader,
  ColumnHeaderContainer,
  ColumnTitle,
  ColumnTitleContainer,
} from './DatatableHeaders.styles';

type DataTableHeaderProps = {
  heading: DataTableHeading;
  tovByAlias: Record<string, { name: () => string }>;
};
const DataTableHeader: FC<DataTableHeaderProps> = ({ heading, tovByAlias }) => {
  const columnName = heading.columnName();

  const tov =
    columnName.alias() && tovByAlias[columnName.alias()]
      ? tovByAlias[columnName.alias()].name()
      : null;

  return (
    <ColumnHeader>
      <ColumnHeaderContainer>
        <ColumnCategory>{tov}</ColumnCategory>
        <ColumnTitleContainer>
          <ColumnTitle>
            <span>{columnName.name()}</span>
          </ColumnTitle>
        </ColumnTitleContainer>
      </ColumnHeaderContainer>
    </ColumnHeader>
  );
};

export default DataTableHeader;
